import * as React from "react";
import { CircleLoaderLarge } from "@/components/ui/circleLoaderLarge";

export const SuccessMessage: React.FC = () => (
  <div className="text-center">
    <div className="mb-4 text-lg font-medium text-ui-paragraph-text">Login successful! Redirecting...</div>

    <div className="mx-auto w-2/5">
      <CircleLoaderLarge />
    </div>
  </div>
);
